module.exports = __webpack_public_path__ + "static/media/mycart_home.95263ae0.png";